'use strict';
import angular from 'angular';
import CoOpBannerController from './co-op-banner.controller';
import CoOpBannerService from './co-op-banner.service';
export default angular.module('eeComUiApp.coOpBanner', [])
    .controller('CoOpBannerController', CoOpBannerController)
    .service('CoOpBannerService', CoOpBannerService)
    .component('coOpBanner', {
    template: require('./co-op-banner.html'),
    controller: CoOpBannerController
})
    .name;
//# sourceMappingURL=index.js.map